export default __webpack_public_path__ + "static/media/md-card-bg-multi-cloud.2bd89af6.png";